/**
 * Âncoras de interface usadas por passos, imagens e tours da ajuda.
 *
 * Cada ID marca um único controle real (`data-help-anchor`). O teste
 * `content/catalog.test.ts` garante que todo ID declarado aqui é aplicado em
 * exatamente uma tela; o tipo `HelpAnchorId` garante que o conteúdo só cita IDs declarados.
 * Em listas, marque o cabeçalho ou o contêiner — nunca cada linha.
 */
export const HELP_ANCHORS = [
  'shell.ajuda',
  'shell.fazenda',
  'nutricao.lista.nova',
  'nutricao.dia.ambientes',
  'nutricao.dia.tratos',
  'nutricao.dia.formula',
  'nutricao.dia.aplicar-todos',
  'nutricao.dia.fornecido',
  'nutricao.dia.salvar-tratos',
  'nutricao.dia.finalizar',
  'nutricao.dia.ficha',
  'cocho.area.navegador',
  'cocho.area.nota',
  'cocho.area.salvar',
  'cocho.area.sobra',
  'manejo.paineis',
  'manejo.peso',
  'manejo.confirmar-animal',
  'manejo.confirmar',
  'relatorios.escolher',
  'relatorios.guia',
] as const;

export type HelpAnchorId = (typeof HELP_ANCHORS)[number];

export function helpAnchor(id: HelpAnchorId): { 'data-help-anchor': HelpAnchorId } {
  return { 'data-help-anchor': id };
}

export function helpAnchorSelector(id: HelpAnchorId): string {
  return `[data-help-anchor="${id}"]`;
}
